module.exports = __webpack_public_path__ + "static/img/giss_navy_anomaly_celsius.e14914e1.png";